var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "relative flex bg-white rounded-lg overflow-hidden shadow-md mb-3",
      class: _vm.cardOpacity,
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-25 flex flex-col justify-center items-center px-2 py-4 relative",
          class: _vm.leftBgClass,
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col items-center",
              class: _vm.leftTextClass,
            },
            [
              _c("div", { staticClass: "flex items-baseline font-bold" }, [
                _c("span", { staticClass: "text-sm mr-1" }, [_vm._v("RM")]),
                _c("span", { staticClass: "text-2xl leading-none" }, [
                  _vm._v(_vm._s(_vm.formatToYuan(_vm.coupon.discountPrice))),
                ]),
              ]),
              _c("span", { staticClass: "text-xs mt-2" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isZh
                        ? `满RM ${_vm.formatToYuan(_vm.coupon.usePrice)}可用`
                        : `Valid with a minimum spend of RM1 ${_vm.formatToYuan(
                            _vm.coupon.minAmount
                          )}`
                    ) +
                    " "
                ),
              ]),
            ]
          ),
        ]
      ),
      _c("div", { staticClass: "flex-1 flex-col flex justify-between p-4" }, [
        _c(
          "div",
          { staticClass: "text-base font-medium mb-2", class: _vm.titleClass },
          [_vm._v(_vm._s(_vm.isZh ? _vm.coupon.name : _vm.coupon.nameEn))]
        ),
        _c("div", { staticClass: "text-xs", class: _vm.dateClass }, [
          _vm._v(
            _vm._s(_vm.formatDate(_vm.coupon.validStartTime)) +
              " - " +
              _vm._s(_vm.formatDate(_vm.coupon.validEndTime))
          ),
        ]),
      ]),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "absolute left-25 top-0 bottom-0 w-0" }, [
      _c("div", {
        staticClass:
          "absolute w-3 h-3 bg-gray-50 rounded-full -left-1.5 -top-1.5",
      }),
      _c("div", {
        staticClass:
          "absolute w-3 h-3 bg-gray-50 rounded-full -left-1.5 -bottom-1.5",
      }),
      _c("div", {
        staticClass:
          "absolute left-0 top-1.5 bottom-1.5 w-px border-l border-dashed border-gray-300",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }